import React from 'react';

import styled from 'styled-components';
import { CoachSurveyBanners } from '../../HomePage/CoachSurvey';
import { ALL_SURVEYS } from '../../HomePage/CoachSurvey/config';
import { JoinSessionBanner } from './JoinSessionBanner';
import { SetupConnectionsBanner } from './SetupConnectionsBanner';

const StyledGlobalAlertContainer = styled.div`
  position: sticky;

  z-index: 2;
  top: 52px;

  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
`;

export enum GlobalBannerType {
  SetupConnections = 'SetupConnections',
  JoinSession = 'JoinSession',
  CoachSurveys = 'CoachSurveys',
}

interface GlobalBannersProps {
  enableBanners: GlobalBannerType[];
}

export const GlobalBanners: React.FC<GlobalBannersProps> = ({
  enableBanners,
}) => {
  const banners = [];

  if (enableBanners.includes(GlobalBannerType.SetupConnections)) {
    banners.push(
      <SetupConnectionsBanner key={GlobalBannerType.SetupConnections} />,
    );
  }

  if (enableBanners.includes(GlobalBannerType.JoinSession)) {
    banners.push(<JoinSessionBanner key={GlobalBannerType.JoinSession} />);
  }

  if (banners.length === 0) {
    return null;
  }

  return (
    <StyledGlobalAlertContainer>
      {banners}
      <CoachSurveyBanners
        key={GlobalBannerType.CoachSurveys}
        configs={ALL_SURVEYS}
      />
    </StyledGlobalAlertContainer>
  );
};
